var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmSymMarkWm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 20,
    viewBox: "0 0 87 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444EE6",
    fillRule: "evenodd",
    d: "M40 .001C40 11.046 31.045 20 20 20 9.07 20 .187 11.231.003.344L0 .001h40zM66.667 0c11.045 0 20 8.954 20 19.999l-40.001-.001.004-.342C46.852 8.883 55.55.185 66.322.003z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmSymMarkWm);
export default __webpack_public_path__ + "static/media/atm-sym-mark-wm.d7587e82adbdbe76e882423f7049b651.svg";
export { ForwardRef as ReactComponent };